import { PopupPositioner } from "@videojs/core/dom";
import { useLayoutEffect, useState } from "react";
//#region src/ui/popover/use-popup-position.ts
const POPOVER_RESET = {
	position: "fixed",
	inset: "auto",
	margin: 0
};
function usePopupPosition({ open, anchorName, position, triggerSource, popupRef, boundary, container, cssVars, trackResize, onSideChange }) {
	const [positioner] = useState(() => new PopupPositioner());
	useLayoutEffect(() => {
		if (!open) {
			positioner.cleanup();
			return;
		}
		positioner.sync({
			anchorName,
			position,
			trigger: triggerSource.triggerElement,
			popup: popupRef.current,
			boundary,
			container,
			...trackResize !== void 0 ? { trackResize } : {},
			...cssVars ? { cssVars } : {},
			...onSideChange ? { onSideChange } : {}
		});
	});
	useLayoutEffect(() => () => positioner.cleanup(), [positioner]);
	return POPOVER_RESET;
}
//#endregion
export { usePopupPosition };

//# sourceMappingURL=use-popup-position.js.map